import { render } from "./Services.vue?vue&type=template&id=f0d173fe&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=f0d173fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0d173fe"

export default script